import { render, staticRenderFns } from "./NotNotificationReasons.vue?vue&type=template&id=79e92964"
import script from "./NotNotificationReasons.vue?vue&type=script&lang=js"
export * from "./NotNotificationReasons.vue?vue&type=script&lang=js"
import style0 from "./NotNotificationReasons.vue?vue&type=style&index=0&id=79e92964&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports